import { html } from "lit";

export function localeSelection(args) {
    if (!args.asyncLanguages) {
        return html`
            <ux-iws-navigation-locale-selection
                close-text="close"
                accept-text="Select language"
                is-shop="false"
            >
                <div
                    slot="headline"
                    class="ux-text-headline ux-text-headline--medium"
                >
                    Language Selection - Select a language
                </div>
                <option
                    data-language-iso="27"
                    data-url="https://www.trumpf.com/pt_BR/"
                    value="pt_BR"
                    >Brasil</option
                >
                <option
                    data-language-iso="31"
                    data-url="https://www.trumpf.com/bg_BG/"
                    value="bg_BG"
                    >Bulgaria</option
                >
                <option
                    data-language-iso="38"
                    data-url="https://www.trumpf.com/en_CA/"
                    value="en_CA"
                    >Canada</option
                >
                <option
                    data-language-iso="01"
                    data-url="https://www.trumpf.cn/en_CN/"
                    value="de_DE"
                    >Germany</option
                >
            </ux-iws-navigation-locale-selection>
        `;
    } else {
        return html`
            <ux-iws-navigation-locale-selection
                close-text="close"
                accept-text="Select language"
                is-shop="false"
                async-url="./mock-data/locale-selection-banner/locales.json"
            >
                <div
                    slot="headline"
                    class="ux-text-headline ux-text-headline--medium"
                >
                    Language Selection - Select a language
                </div>
            </ux-iws-navigation-locale-selection>
        `;
    }
}

export function toolbox() {
    return html`
        <li class="ux-iws-nav__lvl2-toolbox">
            <ux-iws-meta-navigation-toolbox
                active="false"
                url="./generated-mock-data/toolbox-linklist.json"
            ></ux-iws-meta-navigation-toolbox>
        </li>
    `;
}

export function breadcrumb() {
    return html`
        <div
            slot="breadcrumb-navigation"
            class="ux-iws-header__breadcrumb-wrapper"
        >
            <div class="ux-breadcrumb-navigation">
                <ul>
                    <li>
                        <a href="#">
                            <ux-icon name="chevron-left"></ux-icon>Breadcrumb 1
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <ux-icon name="chevron-left"></ux-icon>Breadcrumb 2
                        </a>
                        <ul>
                            <li>
                                <a href="#"
                                    >Flyout 1<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                            <li>
                                <a href="#"
                                    >Abc 2<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                            <li>
                                <a href="#"
                                    >Flyout 3<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                            <li>
                                <a href="#"
                                    >Flyout 4<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                            <li>
                                <a href="#"
                                    >Flyout Lorem 5<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                            <li>
                                <a href="#"
                                    >Flyout 6<ux-icon
                                        name="chevron-right"
                                    ></ux-icon
                                ></a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="#">
                            <ux-icon name="chevron-left"></ux-icon>Breadcrumb 3
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    `;
}
